import { differenceInCalendarDays, format } from 'date-fns'

// Backend ships ``lastUsedAt`` as unix seconds (or null for users who have
// never dictated). Calendar-day diff so "yesterday" follows the user's
// wall-clock day boundary rather than a 24h window — matches the Figma
// where 8:30am today and 9:30pm yesterday both read "Yesterday".
export function formatLastUsedAt(
  unixSeconds: number | null,
  { sentenceCase = false }: { sentenceCase?: boolean } = {}
): string {
  if (unixSeconds === null) return '—'
  const date = new Date(unixSeconds * 1000)
  const days = differenceInCalendarDays(new Date(), date)
  if (days <= 0) return sentenceCase ? 'today' : 'Today'
  if (days === 1) return sentenceCase ? 'yesterday' : 'Yesterday'
  if (days < 7) return `${days} days ago`
  return format(date, 'MMM d, yyyy')
}
